import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../features/auth/useAuth';
import Spinner from '../components/Spinner';

/** Redirects to the auth error page when there is no authenticated session. */
export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, status } = useAuth();
  const location = useLocation();

  // 'idle' / 'loading' means the session is still being resolved — NOT that the
  // user is signed out. Redirecting here would bounce a valid user to
  // /auth-error on every full page load (refresh, direct URL, new tab).
  if (status === 'idle' || status === 'loading') {
    return <Spinner fullPage label="Authenticating…" />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate to="/auth-error" replace state={{ from: location.pathname }} />
    );
  }
  return <>{children}</>;
}
